import {
  AllCapsSubheader,
  BasicInfoBox,
  NoneFoundText,
  Subtitle,
} from 'features/Principal/PrincipalCandidatesList/styles';
import { ATSPrincipalAppCandidateModalTabsTestIds } from 'data-testids/ATS';
import { Box, useTheme } from '@mui/material';
import { ExamsProps } from 'features/Principal/types/modalTypes';
import { EXAMS, getItem, getItemSectionAndScore } from 'components/ApplicationConfirmation/Exams';

export const Exams: React.FC<ExamsProps> = ({ exams }) => {
  const theme = useTheme();

  return (
    <Box data-testid={ATSPrincipalAppCandidateModalTabsTestIds.EXAMS_SECTION}>
      <AllCapsSubheader>Exams</AllCapsSubheader>
      {exams.length == 0 && <NoneFoundText>No exams found</NoneFoundText>}
      {exams?.map((exam) => {
        const examLabel = exam && getItem(exams, EXAMS, exam.type, exam.id);
        const sectionScores = exam && getItemSectionAndScore(exam);

        return (
          <BasicInfoBox
            key={exam.id}
            data-testid={ATSPrincipalAppCandidateModalTabsTestIds.INDIVIDUAL_EXAM}
          >
            <Subtitle>{examLabel}</Subtitle>
            {sectionScores.map((item) => (
              <Box sx={{ color: theme.palette.text.disabled }} key={item}>
                {item}
              </Box>
            ))}
          </BasicInfoBox>
        );
      })}
    </Box>
  );
};
